/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerScheduledPaymentsResponse as ModelsCustomerCustomerScheduledPaymentsResponse } from '../../models/Models/Customer/customer-scheduled-payments-response';

export interface V3CustomersMePaymentsGet$Plain$Params {
  dateFrom?: string;
  dateTo?: string;
}

export function v3CustomersMePaymentsGet$Plain(http: HttpClient, rootUrl: string, params?: V3CustomersMePaymentsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMePaymentsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>;
    })
  );
}

v3CustomersMePaymentsGet$Plain.PATH = '/v3/customers/me/payments';
